const callInvokeNative = function (method, param, callback) {
  if (!window.yugeMedicalBridge) {
    var f = setInterval(function () {
      if (window.yugeMedicalBridge) {
        clearInterval(f);
        try {
          window.yugeMedicalBridge && window.yugeMedicalBridge.invoke("activity:" + method, param, callback);
        } catch (e) {
        }
      }
    }, 2);
  } else {
    try {
      window.yugeMedicalBridge && window.yugeMedicalBridge.invoke("activity:" + method, param, callback);
    } catch (e) {
    }
  }
}

export default callInvokeNative